import { Box, Button, Drawer, Stack, Tooltip } from '@mui/material'
import React, { Component } from 'react'
import '../pharmaReports.css';
import { Colors } from '../../../../Styles/Colors';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
import { AmountFormat } from '../../../../Components/CommonFunctions/CommonFunctions';
import { withTranslation } from 'react-i18next';
import PharmaFilter from '../PharmaFilter';
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

class PurchaseMonthly extends Component {

    constructor(props) {
        super(props)
        this.state = {
            purchaseMonthlyData: [],
            page: 0,
            pageSize: 10,
            rowCount: 0,
            filterDatas: {
                'month': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "days":30
            },
            pageName: 'purchaseMonthly',
            filterOpen: false,
            totalAmount: 0,
            returnAmount: 0,
            isLoader: false,
            tcsAmt:false,
            total_tcs_amount: 0
        }
    }

    componentDidMount() {
        let tcsAmt = JSON.parse(localGetItem('loggedInUserInfo'))
        this.setState({tcsAmt:tcsAmt?.tcs_purchase_applicable})
        this.getPurchaseMonthlydata()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    renderFilter = (data) => {
        this.setState({
            filterDatas: data,
            filterOpen: false,
            page: 0,
        }, () => { this.getPurchaseMonthlydata() })
    }

    ClosePopUp() {
        this.setState({
            filterOpen: false,
        })
    }

    clearFilter = (data) => {
        this.setState({
            filterDatas: data
        })
    }

    formatMonthAndYear = (value) => {
        let month = value.split("-")[1]
        let year = value.split('-')[0]

        return month + "-" + year
    }

    gridToolBar = () => {
        var { t } = this.props
        let TextArray = [
            { label: "Month", value: this.formatMonthAndYear(this.state.filterDatas.month) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>

        )
    }

    getPurchaseMonthlydata = () => {
        try {
            this.LoaderFunction(true);
            RestAPIService.getAll(Serviceurls.PHARMA_PURCHASE_MONTHLY_REPORT_GET + `?month=${this.state.filterDatas?.month?.split("-")[1]}&year=${this.state.filterDatas?.month?.split("-")[0]}&page=${this.state.page + 1}&page_size=${this.state.pageSize}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.LoaderFunction(false);
                        this.setState({
                            purchaseMonthlyData: response.data.data?.bill_details,
                            totalAmount: response.data.data?.total_amount,
                            returnAmount: response.data.data?.return_amount,
                            rowCount: response.data.data?.total_count,
                            total_tcs_amount: response.data.data?.total_tcs_amount
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false);
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getPurchaseMonthlyExcel = () => {
        try {
            this.setState({disableBtn: true})
            RestAPIService.excelGet(Serviceurls.PHARMA_PURCHASE_MONTHLY_REPORT_GET + `?month=${this.state.filterDatas?.month?.split("-")[1]}&year=${this.state.filterDatas?.month?.split("-")[0]}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&export=excel`).
                then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"].split("filename=")[1]
                        // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({disableBtn: false})
                    }
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                    this.setState({disableBtn: false})
                })
        } catch (error) {
            this.errorMessage(error.message);
            this.setState({disableBtn: false})
        }
    }

    PurchaseMonthlyPrint = () => {
        try {
         this.setState({disabled: true})
          RestAPIService.getAll(Serviceurls.PHARMA_PURCHASE_MONTHLY_REPORT_GET + `?month=${this.state.filterDatas?.month?.split("-")[1]}&year=${this.state.filterDatas?.month?.split("-")[0]}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&export=pdf`).
            then((response) => {
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL);
              this.setState({disabled: false})
            }).catch((error) => {
              if(error?.response?.data?.message){
                this.errorMessage(error?.response?.data?.message)
              }else{
                this.errorMessage(error.message)
              }
              this.setState({disabled: false})
            })
        } catch (error) {
          this.errorMessage(error.message)
          this.setState({disabled: false})
        }
      }

    render() {
        const { t } = this.props
        this.state.purchaseMonthlyData.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'date', headerName: "Date", flex: 0.090, align: 'center', headerAlign: 'center',
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.date?.length > 12 ? <Tooltip placement='top' title={params?.row?.date} arrow><div>{params?.row?.date?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.date ? params?.row?.date : '-'}
                </Box>)
            },
            {
                field: 'vendor_name', headerName: "Vendor Name", flex: 0.090,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.vendor_name?.length > 12 ? <Tooltip placement='top' title={params?.row?.vendor_name} arrow><div>{params?.row?.vendor_name?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.vendor_name ? params?.row?.vendor_name : '-'}
                </Box>)
            },
            {
                field: 'bill_no', headerName: "Bill Number", flex: 0.090,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.bill_no?.length > 12 ? <Tooltip placement='top' title={params?.row?.bill_no} arrow><div>{'...' + params?.row?.bill_no?.slice(-12)}</div></Tooltip> :
                        params?.row?.bill_no ? params?.row?.bill_no : '-'}
                </Box>)
            },
            {
                field: 'purchase_order_number', headerName: "Purchase Order No.", flex: 0.090, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.purchase_order_number?.length > 12 ? <Tooltip placement='top' title={params?.row?.purchase_order_number} arrow><div>{params?.row?.purchase_order_number?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.purchase_order_number ? params?.row?.purchase_order_number : '-'}
                </Box>)
            },
            {
                field: 'cgst_amount', headerName: `${"CGST"} (${CurrencySymbol})`, flex: 0.090, type: "number",
                renderCell: ({ row }) => (<Box>{AmountFormat(row?.cgst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
            {
                field: 'sgst_amount', headerName: `${"SGST"} (${CurrencySymbol})`, flex: 0.090, type: "number",
                renderCell: ({ row }) => (<Box>{AmountFormat(row?.sgst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
            {
                field: 'tcs_amount', headerName: `${"TCS"} (${CurrencySymbol})`, flex: 0.090, type: "number",
                renderCell: ({ row }) => (<Box>{AmountFormat(row?.tcs_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
            {
                field: 'taxable_amount', headerName: `${"Taxable Amount"} (${CurrencySymbol})`, flex: 0.090, type: "number",
                renderCell: ({ row }) => (<Box>{AmountFormat(row?.taxable_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
            {
                field: 'amount', headerName: `${"Amount"} (${CurrencySymbol})`, flex: 0.090, type: "number",
                renderCell: ({ row }) => (<Box>{AmountFormat(row?.amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
            {
                field: 'epr_value', headerName: `${'EPR Value'} (${CurrencySymbol})`, flex: 0.090, type: "number",
                renderCell: ({ row }) => (<Box>{AmountFormat(row?.epr_value || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
            },
        ]
    // Commented due to this flow stopped and incase use for furture use
        // const taxableAmount = columns.findIndex(col => col.field === 'taxable_amount');
        // if(this.state.tcsAmt){
        //     columns.splice(taxableAmount + 1, 0, {
        //         field: 'tcs_amount', headerName: `${"TCS"} (${CurrencySymbol})`, flex: 0.090, type: "number",
        //         renderCell: (params) => (<Box>{params.row?.tcs_amount ? params.row?.tcs_amount : '0'}</Box>)
        //     });
        // }
        const disablePrintExcel = this.state.disabled || this.state.purchaseMonthlyData?.length === 0;
        return (
            <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }}>
                <Box component={'div'} className='eMed_Pharma_rts_header'>
                    <Box component={'div'} flex={0.8} display={'flex'}>
                        {AmountsCard("Total", this.state.totalAmount, false, "white", false, null, 'rpt_purmnth_total_amt')}
                        {AmountsCard("Return Amount", this.state.returnAmount, false, "white", false, null, 'rpt_purmnth_rtn_amt')}
                        {AmountsCard("TCS", this.state.total_tcs_amount, false, "white", false, null, 'rpt_purmnth_tcs_amt')}
                    </Box>
                    <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'flex-end'} marginRight={'0.5vw'}>
                        <Button emed_tid="rpt_purmnth_flt" className='eMed_Pharma_rts_btn' onClick={() => this.setState({ filterOpen: true })}>
                            <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' className='eMed_action_img' />
                        </Button>
                        <Button className='eMed_Pharma_rts_btn' disabled={disablePrintExcel} onClick={() => this.PurchaseMonthlyPrint()}>
                            <Box component={'img'} src={disablePrintExcel ? ImagePaths.PrintIconOff.default : ImagePaths.LabPrintIcon.default} alt='print' className='eMed_action_img' />
                        </Button>
                        <Button emed_tid="rpt_purmnth_export" className='eMed_Pharma_rts_btn' disabled={disablePrintExcel} onClick={() => this.getPurchaseMonthlyExcel()}>
                            <Box component={'img'} src={disablePrintExcel ? ImagePaths.ExportIconOff.default : ImagePaths.ExportIcon.default} alt='export' className='eMed_action_img' />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_Pharma_rts_tbl_card'>
                    <DataGrid
                        className='eMed_Pharma_table'
                        rows={this.state.purchaseMonthlyData}
                        columns={columns}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        getRowId={(row) => row['sno']}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        initialState={{
                            columns:{
                                columnVisibilityModel:{
                                    tcs_amount:false
                                }
                            }
                        }}
                        rowCount={this.state.rowCount}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        headerHeight={40}
                        disableSelectionOnClick
                        pagination
                        loading={this.state.isLoader}
                    />
                </Box>

                <Drawer
                    anchor={'right'}
                    open={this.state.filterOpen}
                    ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
                >
                    <PharmaFilter pageName={this.state.pageName} filterDatas={this.state.filterDatas} closeFilter={this.ClosePopUp.bind(this)} filteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} />
                </Drawer>

                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}

export default withTranslation()(PurchaseMonthly)